import React from 'react';

const Payment = () => {
    return (
        <div>
            <h5>Payment system comming soon</h5>
        </div>
    );
};

export default Payment;